const __WEBPACK_NAMESPACE_OBJECT__ = require("@seddi/wa-garments-geometry");